export enum ValueValidationErrorCode {
  FIELD_IS_REQUIRED = 'FIELD_IS_REQUIRED',
  FIELD_MUST_BE_A_STRING = 'FIELD_MUST_BE_A_STRING',
  FIELD_MUST_BE_A_VALID_EMAIL_ADDRESS = 'FIELD_MUST_BE_A_VALID_EMAIL_ADDRESS',
  MAX_LENGTH_EXCEEDED = 'MAX_LENGTH_EXCEEDED',
  MIN_LENGTH_REQUIRED = 'MIN_LENGTH_REQUIRED',
  PROVIDED_VALUE_IS_INVALID = 'PROVIDED_VALUE_IS_INVALID',
  VALUE_SIZE_IS_INVALID = 'VALUE_SIZE_IS_INVALID',
  VALUE_ALREADY_EXISTS = 'VALUE_ALREADY_EXISTS',
  FIELD_MUST_BE_AN_ARRAY = 'FIELD_MUST_BE_AN_ARRAY',
}
